export enum StorageState {
    Normal = 'normal',
    Nearing = 'nearing',
    Critical = 'critical',
    Exceeded = 'exceeded', // USQ uses full and overLimit states. Since they have the same behavior in client side, we merge them into one state.
}
